
















































































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import ModifiedDataHandler from '@/mixins/ModifiedDataHandler'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import isBizRNum from '@/validate/is-biz-r-num'
import isCorpBizRNum from '@/validate/is-corp-biz-r-num'
import {isMobilePhone} from 'validator'
import {initClient, ClientFormData} from '@/pages/issue/constants/init-client'
import {cloneDeep} from 'lodash'
import {delay} from '@/utils'
import {mask} from 'vue-the-mask'
import {Form, FormItem, Select, Option} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import SearchClient from '@/pages/issue/popup/SearchClient.vue'
import SearchAddressPopup from '@/components/popup/btt/SearchAddress.vue'
import TaxRNumInfoPopup from '@/components/popup/btt/TaxRNumInfo.vue'
import ToggleCollapseButton from '@/pages/issue/components/ToggleCollapseButton.vue'
import {Company} from '@/store/modules/companies/types'
import {CreateClientPayload} from '@/store/modules/clients/types'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'

const clients = namespace('clients')
const layout = namespace('layout')
const issue = namespace('issue')
const gtm = namespace('gtm')

@Component({
  components: {
    TaxRNumInfoPopup,
    [Form.name]: Form, [FormItem.name]: FormItem, [Select.name]: Select, [Option.name]: Option,
    TitleAndMessage, MainLayout, HeaderLayout, FooterLayout, FooterButton, ToggleCollapseButton,
    SearchClient, SearchAddressPopup, FloatingLabelInput, [CollapseTransition.name]: CollapseTransition,
  },
  directives: {mask},
})
export default class IssueSetClient extends Mixins(Translation, PopupHandler, ModifiedDataHandler, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: false, type: Boolean}) isConfirm: boolean

  @Ref('formRef') readonly formRef!: Form
  @Ref('nameRef') readonly nameRef!: FloatingLabelInput

  @clients.Action('createClient') createClient: (payload: CreateClientPayload) => Promise<void>
  @clients.Action('getClient') getClient: (payload: {clientId: string}) => Promise<void>
  @layout.Mutation('updateError') updateError: (payload: object) => void
  @issue.State('clientId') clientId: string
  @issue.Getter('gtmCommonInfo') gtmCommonInfo: object
  @issue.Mutation('update') updateIssue: (payload: object) => void
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  visibleExtraData: boolean = false

  clientType: string | null = '1'
  name: string | null = ''
  bizRegistrationNumber: string | null = ''
  ownerName: string | null = ''
  fullAddress: string | null  = ''
  businessType: string | null  = ''
  businessClass: string | null  = ''
  taxRegistrationNumber: string = ''
  sales: boolean | null = null

  /**
   * 아래 3개 연락처 필드는 ClientContact.vue 에서 입력받음
   * 거래처 입력 -> 연락처 입력 -> 확인 단계에서 거래처 수정 하여
   * 새로운 거래처가 생성될 때, 이전에 입력된 연락처 값을 저장하기 위해 사용한다. (contactValues)
   */
  phoneNumber: string | null = ''
  email: string | null  = ''
  emailSub: string | null  = ''

  loading: boolean = true
  visibleDaumcode: boolean = false
  directInput: boolean = false

  get clientTypes(): object {
    return {'1': '사업자', '2': '개인 (준비중)', '3': '외국인 (준비중)'}
  }

  get formModel(): any {
    return {
      clientType: this.clientType,
      name: this.name,
      bizRegistrationNumber: this.bizRegistrationNumber,
      ownerName: this.ownerName,
      fullAddress: this.fullAddress,
      businessType: this.businessType,
      businessClass: this.businessClass,
      taxRegistrationNumber: this.taxRegistrationNumber,
      sales: true,
    }
  }

  get isEnteredExtraData(): boolean {
    return Boolean(this.taxRegistrationNumber)
  }

  get contactValues(): any {
    return {
      phoneNumber: this.phoneNumber,
      email: this.email,
      emailSub: this.emailSub,
    }
  }

  get rules(): object {
    const {ts} = this
    return {
      name: [
        {
          required: true,
          type: 'string',
          message: `${ts('client')}명을 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
      bizRegistrationNumber: [
        {
          required: true,
          validator: (_, value, callback) => {
            if(!value) {
              return callback(new Error(`${ts('business-operator')}${ts('registration-number')}를 ${ts('input')}해주세요`))
            }
            if(!isBizRNum(value)) {
              return callback(new Error(`${ts('business-operator')}${ts('registration-number')}를 올바르게 ${ts('input')}해주세요`))
            }
            return callback()
          },
          trigger: ['change', 'blur'],
        },
      ],
      ownerName: [
        {
          required: true,
          type: 'string',
          message: `${ts('boss')} ${ts('name')}을 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
      phoneNumber: [
        {
          type: 'string',
          validator: (_, value, callback) => {
            if(value && !isMobilePhone(value, 'ko-KR')) {
              return callback(new Error(`${ts('phone-number')}형식에 맞게 ${ts('input')}해주세요`))
            }
            return callback()
          },
          trigger: ['change', 'blur'],
        }
      ],
      email: [
        {
          type: 'email',
          message: `${ts('email')} 형식에 맞게 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
      emailSub: [
        {
          type: 'email',
          message: `${ts('email')} 형식에 맞게 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
      taxRegistrationNumber: [
        {
          trigger: ['blur', 'change'],
          validator: (_, value, callback) => {
            if(value && value.length && value.length < 4) {
              return callback(new Error(`4자리 숫자를 ${ts('input')}해주세요`))
            }
            return callback()
          }
        },
      ],
    }
  }

  @Watch('formModel', {deep: true})
  __formModel(value) {
    this.modifiedData = this.diffData(this.originalData, value)
  }

  @Watch('isEnteredExtraData', {immediate: true})
  __isEnteredExtraData(value) {
    if(value) {
      this.toggleExtraData(true)
    }
  }

  created() {
    if(this.clientId) {
      this.loadClient()
    } else {
      this.loading = false
      this.setOriginalData(this.formModel)
    }
  }

  beforeDestroy() {
    if(this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'confirm_client',
        eventProperties: {
          modified: this.isModifiedData,
          ...this.gtmCommonInfo,
        }
      })
    }
  }

  toggleExtraData(value) {
    this.visibleExtraData = value
  }

  onClickBackward() {
    if(this.isModifiedData) {
      const {message, options} = this.confirmMessageOptions
      this.$confirm(message, options)
        .then(() => {
          this.setClient(this.originalData)
        })
        .then(() => {
          this.$emit('action', 'back')
        })
        .catch((e) => e)
    } else {
      this.$emit('action', 'back')
    }
  }

  onClickDone() {
    this.formRef.validate((valid) => {
      if(valid) {
        this.addClient()
      }
    })
  }

  loadClient() {
    this.getClient({clientId: this.clientId})
      .then((response: any) => {
        this.setClient(response)
        this.setOriginalData(this.formModel)
      })
      .catch((error) => {
        this.updateError({
          id: 'get-client',
          message: `${this.ts('client')} 정보를 불러오는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  addClient() {
    const addData = {
      ...this.formModel,
      ...this.contactValues,
      clientType: Number(this.formModel.clientType),
      isCorporate: isCorpBizRNum(this.formModel.bizRegistrationNumber),
      representative: {
        name: this.formModel?.ownerName,
      },
    }
    delete addData.ownerName
    this.createClient(addData)
      .then((response: any) => {
        this.updateIssue({clientId: response?.id})
        this.$emit('action', 'ok')
        if(!this.isConfirm) {
          this.logEventWithGroups({
            eventType: 'add_client_info',
            eventProperties: {
              'biz_type_updated': Boolean(this.formModel.businessType),
              'branch_number_updated': Boolean(this.formModel.taxRegistrationNumber),
              'workflow': 'issue_invoice',
            }
          })
        }
      })
      .catch((error) => {
        this.updateError({
          id: 'create-client',
          message: `${this.ts('client')}를 추가 하는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
  }

  onSearchAddress() {
    this.visibleDaumcode = true
  }

  clearClient() {
    this.setClient(cloneDeep(initClient))
  }

  selectCompany(data: Company) {
    this.clearClient()
    this.directInput = false
    this.name = data.name
    this.bizRegistrationNumber = data.bizRegistrationNumber
    this.ownerName = data.ownerName
    this.businessType = data.bizType
    this.businessClass = data.bizClass
    this.fullAddress = data.addressRoad || data.addressJibun

    if(!this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'select_company',
        eventProperties: {
          'workflow': 'issue_invoice'
        }
      })
    }
  }

  selectAddress(value = '') {
    this.fullAddress = value
  }

  selectClient(data) {
    this.directInput = false
    this.setClient(data)
    if(!this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'select_client',
        eventProperties: {
          'workflow': 'issue_invoice',
        }
      })
    }
  }

  setClient(data: ClientFormData) {
    this.clientType = data.clientType
    this.name = data.name
    this.bizRegistrationNumber = data.bizRegistrationNumber
    this.ownerName = data.ownerName
    this.fullAddress = data.fullAddress
    this.businessType = data.businessType
    this.businessClass = data.businessClass
    this.taxRegistrationNumber = data.taxRegistrationNumber
    this.phoneNumber = data.phoneNumber
    this.email = data.email
    this.emailSub = data.emailSub
    this.sales = data.sales
  }

  async focusSearchInput() {
    if(this.directInput) {
      return
    }
    this.openPopup('searchClient')
    await delay(0)
    this.nameRef?.blur()
  }

  selectDirectInput(value) {
    this.directInput = true
    this.name = value
  }
}
